import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import bg from '../../images/offer-bg.webp'
import { useMediaQuery } from 'react-responsive';


const Offer = () => {
    const isMobile = useMediaQuery({ query: '(max-width: 991px)' });
    return (
        <div
            className="offer-section position-relative"
            style={{
                backgroundImage: `url(${isMobile ? "/mpricingbg.png" : "/pricingbg.png"})`,
                minHeight: "100dvh",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
            }}
        >
            <Container className="h-100 position-absolute bottom-20%" style={{
        bottom: "8%",
        left: 0,
        right: 0,
    }}>
                <Row className="h-100">
                    <Col lg={7} className="d-flex">
                        <div className="d-flex flex-column justify-content-end h-100 w-100 px-3">

                            <h2 className={`text-capitalize ${isMobile ? 'mb-2' : 'mb-4'}`}>
                                Transparent Pricing <br/>with Special Offers
                            </h2>

                            <h6 className='text-capitalize'>
                                Own a premium <span>3 BHK</span> apartment at <br/>competitive rates,
                                starting at <span>₹6,999/-sft</span>.
                            </h6>

                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Offer
